import config from 'src/config';
import appboyService from 'services/appboy';

function AppConfig($compileProvider, tablelistSdkProvider, sdkConfigProvider, cacheConfigProvider, segmentProvider) {
  // Angular debugging
  // https://docs.angularjs.org/guide/production
  $compileProvider.debugInfoEnabled(config.NODE_ENV !== 'production');

  tablelistSdkProvider.setApiKey(config.TL_API_KEY);
  tablelistSdkProvider.setEnv(config.NODE_ENV);
  tablelistSdkProvider.setUseAuthHeader(true);

  sdkConfigProvider
    .setApiKey(config.TL_API_KEY)
    .setApiBaseUrl(config.SDK_API_URL)
    .setEnableDebugMode(config.NODE_ENV !== 'production')
    // .setEnableSecureCookie(false)
    // .setEnableCookieDomain(false)
    .setEnableSecureCookie(config.NODE_ENV === 'production')
    .setEnableCookieDomain(config.NODE_ENV === 'production')
    .setClient('web')
    .setGetUserOnStartUp(true);

  if (config.NODE_ENV !== 'production') {
    sdkConfigProvider.setCookiePrefix('dev');
  }

  cacheConfigProvider
    .cacheResourceEndpoints('jsSdk.city.resource', [
      'list'
    ]);

  if (config.SEGMENT_WRITE_KEY) {
    segmentProvider
      .setKey(config.SEGMENT_WRITE_KEY)
      .setDebug(config.SEGMENT_DEBUG);
  }

  appboyService.init();

  appboyService.stopWebTracking();
}

AppConfig.$inject = [
  '$compileProvider',
  'TablelistSdkProvider',
  'jsSdk.configProvider',
  'jsSdk.cacheConfigProvider',
  'segmentProvider'
];

export default AppConfig;



// WEBPACK FOOTER //
// ./src/appConfig.js